import { Injectable } from '@angular/core';
import { EMPTY, Observable, ReplaySubject, timer } from 'rxjs';
import { catchError, filter, map, switchMap, takeWhile, tap } from 'rxjs/operators';
import { FeatureFlagEnum } from '../feature-flags.enum';
import { ApiDataService } from './api.data.service';
import { IdleService } from './idle.service';

@Injectable({
  providedIn: 'root'
})
export class ListDefinitionService {
    constructor(private api: ApiDataService){
        
    }
    getListServiceByArea(area: string): Observable<ListDefinition[]> {
        const url = this.api.buildUrl(`listdefinition/byArea/${area}`);
        return this.api.get(url);
    }
    postListService(listDefinition: ListDefinition): Observable<ListDefinition>{
        const url = this.api.buildUrl('listdefinition');
        return this.api.post(url, listDefinition);
    }
}
export class ListDefinition {
    _id : string;
    fleetHDArea : Array<string>;
    dataType : string;
    data: Array<ListDefinitionData>;
    labelText : string;
    isRequired : boolean;
    anyValue : boolean;
    displayBoth : boolean;
    reverseDisplay : boolean;
    initialValue : string;
}
export class ListDefinitionData {
    key: string;
    value: string;
}